<template>
  <v-layout justify-center class="will-change">
    <v-dialog v-model="dialog" persistent max-width="800px" :retain-focus="false">
      <v-card>

        <v-card-title>
          <v-btn
            color="#000"
            icon
            style="margin-left: -10px"
            @click="fechar()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="headline ml-3">Cadastro de configuração de caixa de e-mail</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="mt-3">
          <div class="text-center font-16 pb-3">
            <template v-for="(item, index) in status" >
              <p :key="index" :style="{ color: item.status === 200 ? '' : 'red' }">
                {{ item.text }}
              </p>
            </template>
          </div>

          <div class="pb-2">
            <v-row>
              <v-col class="py-2" cols="6">
                <v-text-field
                  outlined
                  v-model="config.host"
                  label="MAIL HOST*"
                  autofocus
                  placeholder="Exemplo: smtp.systock.com.br"
                  color="#042333"
                  :error-messages="hostErrors"
                  @input="$v.config.host.$touch()"
                  @blur="$v.config.host.$touch()"
                  @keyup="salvo = false"
                ></v-text-field>
              </v-col>
              <v-col class="py-2" cols="6">
                <v-text-field
                  outlined
                  v-model="config.port"
                  label="MAIL PORT*"
                  color="#042333"
                  placeholder="Exemplo: 587"
                  :error-messages="portErrors"
                  @input="$v.config.port.$touch()"
                  @blur="$v.config.port.$touch()"
                  @keyup="salvo = false"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div class="pb-2">
            <v-row>
              <v-col class="py-2" cols="6">
                <v-text-field
                  outlined
                  v-model="config.user_name"
                  label="MAIL USER NAME*"
                  color="#042333"
                  placeholder="Exemplo: exemplo@systock.com.br"
                  :error-messages="userNameErrors"
                  @input="$v.config.user_name.$touch()"
                  @blur="$v.config.user_name.$touch()"
                  @keyup="config.from = config.user_name;salvo = false;"
                ></v-text-field>
              </v-col>

              <v-col class="py-2" cols="6">
                <v-text-field
                  outlined
                  v-model="config.password"
                  label="MAIL PASSWORD*"
                  color="#042333"
                  autocomplete="new-password"
                  :type="showPassword ? 'text' : 'password'"
                  :error-messages="passwordErrors"
                  @input="$v.config.password.$touch()"
                  @blur="$v.config.password.$touch()"
                  append-icon="mdi-eye"
                  @click:append="showPassword = !showPassword"
                  @keyup="salvo = false"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div class="pb-2">
            <v-row>
              <v-col class="py-2" cols="6">
                <v-text-field
                  outlined
                  v-model="config.from"
                  label="MAIL FROM ADDRESS*"
                  color="#042333"
                  placeholder="exemplo@systock.com.br"
                  :error-messages="fromErrors"
                  @input="$v.config.from.$touch()"
                  @blur="$v.config.from.$touch()"
                  @keyup="config.user_name = config.from;salvo = false;"
                ></v-text-field>
              </v-col>

              <v-col class="py-2" cols="6">
                <v-text-field
                  outlined
                  v-model="config.from_descricao"
                  label="MAIL FROM NAME*"
                  color="#042333"
                  placeholder="Titulo e-mail"
                  :error-messages="fromDescricaoErrors"
                  @input="$v.config.from_descricao.$touch()"
                  @blur="$v.config.from_descricao.$touch()"
                  @keyup="salvo = false"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div class="mb-8" v-if="configCadastradas && salvo">
            <v-btn class="primary" @click="testarEnvioEmail()">
              <span>TESTAR CONFIGURAÇÃO DE E-MAIL</span>
              <v-icon>mdi-test</v-icon>
            </v-btn>
          </div>
        </v-card-text>

        <v-card-actions style="margin-top: -25px">
          <v-spacer></v-spacer>
          <v-btn text @click="fechar()">Fechar</v-btn>
          <v-btn text @click="salvarConfigs()">Salvar</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import MailAPI from "../../../api/mail";

export default {
  name: 'CadastroConfigsSMTP.vue',
  props: ['dialog', 'configCadastradas'],
  data () {
    return {
      showPassword: false,
      status: [],
      config: {
        host: '',
        user_name: '',
        password: '',
        port: '',
        from: '',
        from_descricao: ''
      },
      salvo: false
    }
  },
  validations: {
    config: {
      host: {
        required
      },
      user_name: {
        required,
        email
      },
      password: {
        required
      },
      port: {
        required,
        int () {
          return (this.config.port > 0)
        }
      },
      from: {
        required,
        email
      },
      from_descricao: {
        required
      }
    }
  },
  computed: {
    hostErrors () {
      const errors = [];
      if (!this.$v.config.host.$dirty) return errors;
      !this.$v.config.host.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    userNameErrors () {
      const errors = [];
      if (!this.$v.config.user_name.$dirty) return errors;
      !this.$v.config.user_name.required && errors.push("Campo Obrigatório.");
      !this.$v.config.user_name.email && errors.push("E-mail inválido.");
      return errors;
    },
    passwordErrors () {
      const errors = [];
      if (!this.$v.config.password.$dirty) return errors;
      !this.$v.config.password.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    portErrors () {
      const errors = [];
      if (!this.$v.config.port.$dirty) return errors;
      !this.$v.config.port.required && errors.push("Campo Obrigatório.");
      !this.$v.config.port.int && errors.push("Campo numérico inteiro.");
      return errors;
    },
    fromErrors () {
      const errors = [];
      if (!this.$v.config.from.$dirty) return errors;
      !this.$v.config.from.required && errors.push("Campo Obrigatório.");
      !this.$v.config.from.email && errors.push("E-mail inválido.");
      return errors;
    },
    fromDescricaoErrors () {
      const errors = [];
      if (!this.$v.config.from_descricao.$dirty) return errors;
      !this.$v.config.from_descricao.required && errors.push("Campo Obrigatório.");
      return errors;
    }
  },
  watch: {
    dialog () {
      if (this.dialog) {
        this.buscarConfiguracao()
        this.buscarEmailUsuario()
      }

      if (this.configCadastradas) {
        this.salvo = true
      }
    }
  },
  methods: {
    fechar () {
      this.$emit('fechar-dialog')
      this.$v.$reset()
      this.status = []
    },
    buscarEmailUsuario () {
      if (!this.configCadastradas) {
        const headers = this.Helpers.iniciarRequisicao()

        this.$store.dispatch(
          "loading/addRequisicao",
          MailAPI.getEmailUsuario(headers)
            .then((response) => {
              const {token, email} = response.data
              localStorage.setItem("token", token)
              this.config.user_name = email
              this.config.from = email
            })
        )
      }
    },
    buscarConfiguracao () {
      if (this.configCadastradas) {
        const headers = this.Helpers.iniciarRequisicao()

        this.$store.dispatch(
          "loading/addRequisicao",
          MailAPI.getConfiguracaoEmail(headers)
            .then((response) => {
              const {token, configs} = response.data
              localStorage.setItem("token", token)
              this.config = configs
            })
        )
      }
    },
    testarEnvioEmail () {
      this.status = []
      const headers = this.Helpers.iniciarRequisicao()

      this.$store.dispatch(
        "loading/addRequisicao",
        MailAPI.testarEnvioEmail(headers)
          .then((response) => {
            const { token, erros } = response.data
            localStorage.setItem("token", token)

            if (erros.length) {
              this.status = [{ status: 400, text: 'Erro ao enviar e-mail'}]
            } else if (erros.status === 401) {
              this.status = [{ status: 400, text: 'Configuração de e-mail falhou!'}]
            } else {
              this.status = [
                { status: 200, text: 'Um e-mail teste foi enviado a sua caixa de e-mails.'}
              ]
            }
          })
      )
    },
    salvarConfigs () {
      this.status = []
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao()

        this.$store.dispatch(
          "loading/addRequisicao",
          MailAPI.cadastroSmtpMail(headers, this.config)
            .then((response) => {
              const { token } = response.data;
              localStorage.setItem("token", token);

              this.$emit('configs-cadastradas')
              this.status = [{status: 200, text: 'Salvo com sucesso.' }]
              this.salvo = true
          })
        );
      }
    },
  }
}
</script>

<style scoped>
.font-16 {
  font-size: 16px;
}
 .will-change {
   will-change: transform;
 }
</style>
